<template>
    <div :class="['options-type-1-button', cssClass]">
        <div class="toggle-btn">
            <div :class="`icon-${icon}-neg icon-xs`"></div>
            <span>{{ $t(label) }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "OptionsPanelButton",
        props: {
            cssClass: {
                type: String,
                required: false
            },
            label: {
                type: String,
                default: 'common.search_filter_sort'
            },
            icon: {
                type: String,
                default: 'search'
            }
        }
    }
</script>